import React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import Music from "source/app/services/Sound/Music/Music";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IMusicMenuState } from "../Music/IMusicMenuState";

export function ToggleMusic({ isMusicPlaying }: { isMusicPlaying: boolean }) {
    return (
        <span
            style={{
                color: isMusicPlaying ? `yellowgreen` : `inherit`,
            }}
        >
            <IconWithText
                iconSuffix={EGlyphicon.music}
                whenClicked={() => {
                    isMusicPlaying
                        ? Music.Stop()
                        : Music.StartNextSong();

                    State.ReadClass<IMusicMenuState>(
                        ESharedComponent.MusicMenu
                    ).setState({
                        currentFileInfo: undefined,
                    });
                }}
                displayAsBlock
                customStyle={{ margin: 0 }}
            >
                {isMusicPlaying ? `Music ON` : `Music OFF`}
            </IconWithText>
        </span>
    );
}
